import SearchOffIcon from '@mui/icons-material/SearchOff';
import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import { QuestionFormAdvanced } from '../components/QuestionForm/QuestionFormAdvanced';
import { useBuscarQuestaoPesquisa } from '../hooks/useBuscarQuestaoPesquisa';
import { useResponderPesquisa } from '../hooks/useResponderPesquisa';
import { Question } from '../types/questionnaire.types';

const UseCase002: React.FC = () => {
  const { event } = useParams<{ event: string }>();
  // const location = useLocation();

  // Ler os query parameters
  // const queryParams = new URLSearchParams(location.search);
  // const codNre = queryParams.get('codNre');
  // const nre = queryParams.get('nre');
  // const codMun = queryParams.get('codMun');
  // const mun = queryParams.get('mun');
  // const codMec = queryParams.get('codMec');
  // const escola = queryParams.get('escola');
  // const cargoId = queryParams.get('cargoId');
  // const cargo = queryParams.get('cargo');

  // Log para verificar os valores
  // console.log('Parâmetros recebidos:', {
  //   event,
  //   codNre,
  //   nre,
  //   codMun,
  //   mun,
  //   codMec,
  //   escola,
  //   cargoId,
  //   cargo,
  // });

  // const dadosServidor: DadosServidor = {
  //   nomeFuncionario: localStorage.getItem('name')?.toUpperCase() || '',
  //   codNre: codNre || '',
  //   descNre: nre?.toUpperCase() || '',
  //   codMun: codMun || '',
  //   descMun: mun?.toUpperCase() || '',
  //   codMec: codMec || '',
  //   descEscola: escola?.toUpperCase() || '',
  //   funcaoId: cargoId || '',
  //   funcao: cargo?.toUpperCase() || '',
  //   event: event || '',
  // };

  // Renomeando as variáveis para evitar conflito
  const {
    data: questoesData,
    isLoading: questoesLoading,
    error: questoesError,
  } = useBuscarQuestaoPesquisa(event);

  // const {
  //   data: dadosServidor,
  //   isLoading: servidorLoading,
  //   error: servidorError,
  // } = useBuscarDadosServidor(event);

  const { submitRespostas, isSubmitting } = useResponderPesquisa();

  //   const { submitRespostas, isSubmitting } = useResponderPesquisa();

  const handleSubmit = (responses: any) => {
    // console.log('respostas enviadas:', responses);
    // console.log('dados do servidor:', dadosServidor);
    submitRespostas({
      respostas: responses,
      // dadosServidor,
      eventUId: event,
    });
  };

  // const handleSubmit = (responses: any) => {
  //   console.log('respostas enviadas:', responses);
  //   console.log('Contexto da pesquisa:', {
  //     codNre,
  //     nre,
  //     codMun,
  //     mun,
  //     codMec,
  //     escola,
  //     cargoId,
  //     cargo,
  //   });

  //   submitRespostas({
  //     respostas: responses,
  //     eventUId: event,
  //   });
  // };

  const questions: Question[] = questoesData
    ? Array.isArray(questoesData)
      ? questoesData
      : [questoesData]
    : [];

  // Verificando loading de ambos os hooks
  // if (questoesLoading || servidorLoading) {
  if (questoesLoading) {
    return (
      <Grid item xs={12} sx={{ marginTop: '5rem' }}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="50vh"
        >
          <CircularProgress />
        </Box>
      </Grid>
    );
  }

  // Verificando erro de ambos os hooks
  // if (questoesError || servidorError) {
  if (questoesError) {
    return (
      <Grid item xs={12} sx={{ marginTop: '5rem' }}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="50vh"
        >
          <p>Erro ao carregar a pesquisa. Tente novamente.</p>
        </Box>
      </Grid>
    );
  }

  // if (!questoesData || questions.length === 0) {
  //   return (
  //     <Grid item xs={12} sx={{ marginTop: '5rem' }}>
  //       <Box
  //         display="flex"
  //         justifyContent="center"
  //         alignItems="center"
  //         minHeight="50vh"
  //       >
  //         <p>Nenhuma questão encontrada.</p>
  //       </Box>
  //     </Grid>
  //   );
  // }

  if (!questoesData || questions.length === 0) {
    return (
      <Grid item xs={12} sx={{ marginTop: '5rem' }}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight="50vh"
          gap={2}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: '50%',
              bgcolor: 'grey.100',
              border: '1px solid',
              borderColor: 'grey.300',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <SearchOffIcon sx={{ color: 'text.secondary', fontSize: 28 }} />
          </Box>
          <Box textAlign="center">
            <Typography variant="body1" fontWeight={500} gutterBottom>
              Nenhuma prova encontrada
            </Typography>
          </Box>
        </Box>
      </Grid>
    );
  }

  return (
    <Grid item xs={12} sx={{ marginTop: '5rem' }}>
      <QuestionFormAdvanced
        questions={questions}
        // dadosServidor={dadosServidor}
        onSubmit={handleSubmit}
        submitButtonText={isSubmitting ? 'SUBMITTING...' : 'SUBMIT'}
        timeLimit={0}
      />
    </Grid>
  );
};

export default UseCase002;

// import { Box, CircularProgress, Grid } from '@mui/material';
// import React from 'react';
// import { useParams } from 'react-router-dom';
// import { QuestionFormAdvanced } from '../components/QuestionForm/QuestionFormAdvanced';
// import { useBuscarDadosServidor } from '../hooks/useBuscarDadosServidor';
// import { useBuscarQuestaoPesquisa } from '../hooks/useBuscarQuestaoPesquisa';
// import { useResponderPesquisa } from '../hooks/useResponderPesquisa';
// import { Question } from '../types/questionnaire.types';

// const UseCase002: React.FC = () => {
//   const { event } = useParams<{ event: string }>();

//   // Renomeando as variáveis para evitar conflito
//   const {
//     data: questoesData,
//     isLoading: questoesLoading,
//     error: questoesError,
//   } = useBuscarQuestaoPesquisa(event);

//   const {
//     data: dadosServidor,
//     isLoading: servidorLoading,
//     error: servidorError,
//   } = useBuscarDadosServidor(event);

//   const { submitRespostas, isSubmitting } = useResponderPesquisa();

//   const handleSubmit = (responses: any) => {
//     console.log('respostas enviadas:', responses);
//     submitRespostas({
//       respostas: responses,
//       eventUId: event,
//     });
//   };

//   const questions: Question[] = questoesData
//     ? Array.isArray(questoesData)
//       ? questoesData
//       : [questoesData]
//     : [];

//   // Verificando loading de ambos os hooks
//   if (questoesLoading || servidorLoading) {
//     return (
//       <Grid item xs={12} sx={{ marginTop: '5rem' }}>
//         <Box
//           display="flex"
//           justifyContent="center"
//           alignItems="center"
//           minHeight="50vh"
//         >
//           <CircularProgress />
//         </Box>
//       </Grid>
//     );
//   }

//   // Verificando erro de ambos os hooks
//   if (questoesError || servidorError) {
//     return (
//       <Grid item xs={12} sx={{ marginTop: '5rem' }}>
//         <Box
//           display="flex"
//           justifyContent="center"
//           alignItems="center"
//           minHeight="50vh"
//         >
//           <p>Erro ao carregar a pesquisa. Tente novamente.</p>
//         </Box>
//       </Grid>
//     );
//   }

//   if (!questoesData || questions.length === 0) {
//     return (
//       <Grid item xs={12} sx={{ marginTop: '5rem' }}>
//         <Box
//           display="flex"
//           justifyContent="center"
//           alignItems="center"
//           minHeight="50vh"
//         >
//           <p>Nenhuma questão encontrada.</p>
//         </Box>
//       </Grid>
//     );
//   }

//   return (
//     <Grid item xs={12} sx={{ marginTop: '5rem' }}>
//       <QuestionFormAdvanced
//         questions={questions}
//         dadosServidor={dadosServidor}
//         onSubmit={handleSubmit}
//         submitButtonText={isSubmitting ? 'ENVIANDO...' : 'ENVIAR PESQUISA'}
//         timeLimit={0}
//       />
//     </Grid>
//   );
// };

// export default UseCase002;
